

















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import transitionExpand from '../../ui/TransitionExpand.vue';
import LegendOptions from '@/components/docs-main/reference-pages/LegendOptions.vue';
import { uppercaseKinds } from '@/heplers';

@Component({
  components: {
    transitionExpand,
    LegendOptions,
  },
  filters: {
    capitalizeName: (name: string) => {
      return uppercaseKinds[name];
    },
  },
})
export default class Legend extends Vue {
  @Prop(Object) legendData: any;
  public showLegend = true;
  private expanded = true;

  get chevronStateClass() {
    return this.expanded ? 'chevron-open' : 'chevron-close';
  }

  get isIntroduction() {
    return this.$route?.meta?.fqdn.split('.')[0] === 'introduction';
  }

  get computeReferencesDataName() {
    return this.isIntroduction ? 'Table of content' : 'Reference map';
  }

  computeKindName(kind: string) {
    if (!this.isIntroduction) return this.$options.filters.capitalizeName(kind);

    if (kind === 'tutorial') return 'Articles';

    if (kind === 'folder') return 'Chapters';

    return this.$options.filters.capitalizeName(kind);
  }
}
